import React, { useState } from "react"
import { settings } from "../views/ProgramMode";
import { White } from 'react-dial-knob'
import Grid from "@material-ui/core/Grid";
import CountUp from "react-countup";
import { getCookingTerm, MIN_GRILL_TEMP_F, MAX_GRILL_TEMP_F, MIN_PROD_TEMP_F, MAX_PROD_TEMP_F, MIN_TIME_S, MAX_TIME_S, GRILL_TEMP_STEP_F, PROD_TEMP_STEP_F, TIME_STEP_S } from "../utils/constants";
import { mainBgColor, borderColor } from "../utils/colors";
import ambientTemp from "../assets/ambientTemp.png";
import Clock from "../assets/clock-icon.png";
import prodTemp from "../assets/productTemp.png";

const theme = {
  activeColor: mainBgColor,
  defaultColor: 'black',
  activeNotchColor: mainBgColor,
  defaultNotchColor: 'white',
  activeTextColor: borderColor,
}

export default function Setter({ setting, stage, setStage, category, ...params }) {

  const { product_temperature_f, grill_temperature_f, time_s, id } = { ...stage }

  switch (setting) {
    case (settings.TIME):
      return <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          width="80px"
          style={{ borderRadius: 20, padding: 10 }}
          src={Clock}
        />
        <p style={{ fontSize: 35, textAlign: "center" }}>
          Set Time (s)
        </p>
        <White
          diameter={200}
          min={MIN_TIME_S}
          max={MAX_TIME_S}
          step={TIME_STEP_S}
          value={time_s}
          theme={theme}
          onValueChange={val => {
            setStage({
              id,
              grill_temperature_f,
              time_s: val
            })
          }}
          ariaLabelledBy={'my-label'}
        />
      </Grid>
    case (settings.PRODUCT_TEMP):
      return <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          width="80px"
          style={{ borderRadius: 20, padding: 10 }}
          src={prodTemp}
        />
        <p style={{ fontSize: 35, textAlign: "center" }}>
          Product Set Temperature
        </p>
        <White
          diameter={200}
          min={MIN_PROD_TEMP_F}
          max={MAX_PROD_TEMP_F}
          step={PROD_TEMP_STEP_F}
          value={product_temperature_f}
          theme={theme}
          onValueChange={val => {
            setStage({
              id,
              grill_temperature_f,
              product_temperature_f: val
            })
          }}
          ariaLabelledBy={'my-label'}
        />
        <p style={{ fontSize: 35, textAlign: "center", borderBottom: "2px solid", width: 130 }}>
          <CountUp
            start={0}
            end={product_temperature_f}
            duration={1}
          /> °F
        </p>
        <p style={{ fontSize: 35, textAlign: "center", width: 130 }}>
          {getCookingTerm(category, product_temperature_f)}
        </p>
      </Grid>

    case (settings.GRILL_TEMP):
      return <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          width="80px"
          style={{ borderRadius: 20, padding: 10 }}
          src={ambientTemp}
        />
        <p style={{ fontSize: 35, textAlign: "center" }}>
          Grill Set Temperature
        </p>
        <White
          diameter={200}
          min={MIN_GRILL_TEMP_F}
          max={MAX_GRILL_TEMP_F}
          step={GRILL_TEMP_STEP_F}
          value={grill_temperature_f}
          theme={theme}
          onValueChange={val => {
            setStage({
              id,
              ...(time_s && { time_s }),
              ...(product_temperature_f && { product_temperature_f }),
              grill_temperature_f: val
            })
          }}
          ariaLabelledBy={'my-label'}
        />
        <p style={{ fontSize: 35, textAlign: "center", borderBottom: "2px solid", width: 130 }}>
          <CountUp
            start={0}
            end={grill_temperature_f}
            duration={1}
          /> °F
        </p>
      </Grid>

    case (settings.ACTION):
      return <h3>Perform Action</h3>
  }

}